type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  readClients: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}
export type ClientData = {
  cpf: string
  created_at: string
  deleted_at?: string
  email: string
  id: number
  name: string
  status: string
  type: string
  values?: string
  updated_at: string
}

export type ClientsData = {
  id: number
  cpf: string
  name: string
  payment_form: string
  status: string
  values: number
  created_at: string
  updated_at: string
  deleted_at?: string
}

const nameEntity = 'Client'
const nameSource = 'commercial/clients'
const namePageTitle = 'Clientes'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Clientes',
  to: '/commercial/clients',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/clients/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/clients/',
    icon: 'fa fa-list'
  },
  readClients: {
    name: 'Contratos',
    to: '/commercial/clients/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/clients/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
